import React from 'react';

export const Clock = ({ customStyles }: { customStyles: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="57"
			height="56"
			fill="none"
			viewBox="0 0 57 56"
			className={customStyles}
		>
			<path
				fill="#339D37"
				d="M26.496 12.25c0-.875.766-1.75 1.75-1.75.875 0 1.75.875 1.75 1.75v14.875l9.625 6.453c.875.547 1.094 1.64.547 2.406-.547.875-1.64 1.094-2.406.547l-10.5-7A1.745 1.745 0 0126.387 28l.11-15.75zM28.246 0c15.422 0 28 12.578 28 28 0 15.531-12.578 28-28 28-15.531 0-28-12.469-28-28 0-15.422 12.469-28 28-28zm-24.5 28c0 13.563 10.938 24.5 24.5 24.5 13.453 0 24.5-10.938 24.5-24.5 0-13.453-11.047-24.5-24.5-24.5-13.562 0-24.5 11.047-24.5 24.5z"
			></path>
		</svg>
	);
};
